
import ServiceConfigAdminList from './src/ServiceConfigAdmin/ServiceConfigAdminList.vue' //预警设置-管理员列表
import ServiceConfigAdminEdit from './src/ServiceConfigAdmin/ServiceConfigAdminEdit.vue' //预警设置-管理员详情 
import ServiceConfigUserList from './src/ServiceConfigUser/ServiceConfigUserList.vue' //预警设置-用户列表
import ServiceConfigUserEdit from './src/ServiceConfigUser/ServiceConfigUserEdit.vue' //预警设置-用户详情
import RegionThresholdConfigView from './src/RegionThresholdConfig/RegionThresholdConfigView.vue' //客流区域阈值设置-列表
import RegionThresholdConfigEdit from './src/RegionThresholdConfig/RegionThresholdConfigEdit.vue' //客流区域阈值设置-详情  

let views = {
  ServiceConfigAdminList,
  ServiceConfigAdminEdit,
  ServiceConfigUserList,
  ServiceConfigUserEdit,
  RegionThresholdConfigView,
  RegionThresholdConfigEdit
};

export default views;